import {
	CreateUpcomingOnlineCourseDto,
	restRepository,
} from "@onair/repositories";
import { GetOnlineCourseInput } from "../../online-course";

export const getListOnlineCourseByAdmin = async (
	input: GetOnlineCourseInput,
) => {
	const response = await restRepository.api.onlineCourseGetListByAdmin(input);
	return response.data;
};

export const createUpcomingCourse = async (
	input: CreateUpcomingOnlineCourseDto,
) => {
	const response =
		await restRepository.api.createUpcomingOnlineCourseByAdmin(input);
	return response.data;
};

export const updateUpcomingCourse = async (
	id: string,
	input: CreateUpcomingOnlineCourseDto,
) => {
	const response =
		await restRepository.api.updateUpcomingOnlineCourseByAdmin(id, input);
	return response.data;
};
